"use strict";

require("core-js/modules/web.dom-collections.iterator.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _reconnectingWebsocket = _interopRequireDefault(require("reconnecting-websocket"));

var _reactPushNotification = _interopRequireDefault(require("react-push-notification"));

var _reactToastify = require("react-toastify");

var _notification = require("../../actions/notification");

var _nucoinLogo = _interopRequireDefault(require("../../assets/nucoin-logo.png"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

class Socket extends _react.Component {
  componentDidMount() {
    const {
      connectionURL,
      projectKey,
      userAuthToken
    } = this.props;
    const ws = new _reconnectingWebsocket.default("".concat(connectionURL, "/").concat(projectKey, "/"), ['Token', userAuthToken]);
    this.registerListeners(ws);
    this.props.setSocketConnection(ws);
  }

  registerListeners(ws) {
    ws.onmessage = event => {
      let data = JSON.parse(event.data);

      switch (data.category) {
        case 'header':
          {
            this.props.setNewHeaderMessage(data);
            break;
          }

        case 'announcement':
          {
            this.props.setNewAnnouncement(_objectSpread(_objectSpread({}, data), {}, {
              userpreferences: {
                is_read: false
              }
            }));
            break;
          }

        default:
          {
            this.props.setNewMessage(_objectSpread(_objectSpread({}, data), {}, {
              userpreferences: {
                is_read: false
              }
            }));
            break;
          }
      } // const message = data.message.length <= 70 ? `${data.message}` : `${data.message.substring(0, 70) + "..."}`;


      const title = data.title.length <= 70 ? "".concat(data.title) : "".concat(data.title.substring(0, 70) + "...");
      (0, _reactToastify.toast)( /*#__PURE__*/_react.default.createElement("div", {
        className: "ToastPopup"
      }, /*#__PURE__*/_react.default.createElement("p", null, title), /*#__PURE__*/_react.default.createElement("div", {
        className: "media align-items-top"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "media-left mr-3"
      }, /*#__PURE__*/_react.default.createElement("figure", null, /*#__PURE__*/_react.default.createElement("img", {
        src: _nucoinLogo.default,
        alt: ""
      }))), /*#__PURE__*/_react.default.createElement("div", {
        className: "media-body"
      }, /*#__PURE__*/_react.default.createElement("h4", {
        className: "m-0"
      }, title), /*#__PURE__*/_react.default.createElement("span", null, "Just now")))), {
        position: "top-right",
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        progress: undefined
      }); // toast(title);

      if (data.is_web_push) {
        (0, _reactPushNotification.default)({
          title: 'New Message',
          subtitle: "subtitle",
          //optional
          message: "( ".concat(data['sender'], " ) ").concat(data['message']),
          //optional
          // icon: icon,
          theme: 'light',
          //optional, default: undefined
          duration: 3000,
          //optional, default: 5000,
          backgroundTop: 'green',
          //optional, background color of top container.
          backgroundBottom: 'darkgreen',
          //optional, background color of bottom container.
          colorTop: 'green',
          //optional, font color of top container.
          colorBottom: 'darkgreen',
          //optional, font color of bottom container.
          closeButton: 'Go away',
          //optional, text or html/jsx element for close text. Default: Close,
          native: true //optional, makes the push notification a native OS notification  

        });
      }
    };
  }

  render() {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
  }

}

const mapStateToProps = state => ({
  connection: state.Notification.connection
});

var _default = (0, _reactRedux.connect)(mapStateToProps, {
  setSocketConnection: _notification.setSocketConnection,
  setNewMessage: _notification.setNewMessage,
  setNewAnnouncement: _notification.setNewAnnouncement,
  setNewHeaderMessage: _notification.setNewHeaderMessage
})(Socket);

exports.default = _default;